import { render } from "./AdminEventListItem.vue?vue&type=template&id=d1ffb3e6"
import script from "./AdminEventListItem.vue?vue&type=script&lang=js"
export * from "./AdminEventListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__